module.exports = __webpack_public_path__ + "static/media/footer-icon-dark-4.8b150a15.svg";